import { MainContext } from "context/mainContext";
import React, { useEffect, useState, useCallback, useContext } from "react";
import { Button } from "reactstrap";

function EVADashboardAnswer({ answer, query, isWelcomeMessage, handleSendEVAStreamMessage, isDefaultDashboard, quickFilter }) {
    const [showMore, setShowMore] = useState(true);
    const [templates, setTemplates] = useState([])
    const { bgColor, textColor, userDetails } = useContext(MainContext);

    // useEffect(() => {
    //     setShowMore(query?.length === 0);
    //     const templates = answer.match(/\*\*(.*?)\*\*/g).map(template => template.replace(/\*\*/g, ''));
    //     // console.log(templates);
    //     setTemplates(templates)
    // }, [query]);

    const handleClick = useCallback(({ href, text }) => {
        handleSendEVAStreamMessage(text)
    }, []);

    useEffect(() => {
        setShowMore(query?.length === 0);
        const matches = [...answer.matchAll(/\*\*(.*?)\*\*\s*:\s*(.*?)(?=\n\d+\.\s+\*\*|$)/gs)];
    
        const templatesWithDescription = matches.map(([, title, description]) => ({
            title: title.trim(),
            description: description.trim()
        }));
        setTemplates(templatesWithDescription);
    }, [query]);

    return (
        <div style={{ fontWeight: '500', fontSize: 13 }}>
            <div>Hi {userDetails.User.FirstName}, I'm EVA, your AI Dashboard Builder. I can build dynamic dashboards for you based on your business needs. </div>
            <br></br>

            <div className="mb-3">Are you stuck to begin with? See below 7 ideas that are popular in the market right now which you can load immediately.</div>
            <div className="default-dashboard-container">
                {templates.length > 0 && templates.map((item, index) => (
                    <div className="default-dashboard-item-container" key={index}>
                        <a 
                            key={index} 
                            className="default-dashboard-item" 
                            style={{ background: bgColor , color: textColor }} 
                            onClick={() => handleSendEVAStreamMessage(`category: ${item.title}`)}
                        >
                            {item.title} Dashboard
                        </a>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
            <div>Otherwise , why not use quick filters to select a category and sub category - then guide me more with what you want to focus on, explaining what you would like inside your dashboard. Leave it with me to build you something amazing!</div>
            
        </div>
    );
}

export default EVADashboardAnswer;
